<template>
  <!-- 添加用户 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="添加用户"
      width="700px"
      @close="closeDialog"
    >
      <div class="set-user">
        <el-form :inline="true" label-width="90px">
          <el-form-item label="用户id：">
            <el-input
              style="width: 150px"
              v-model="user_id"
              placeholder="请输入用户id"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getData"
              >搜索</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="submit"
              :loading="buttonLoading"
              >添加</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model="allSwitchValue"
              :active-value="1"
              :inactive-value="0"
              active-text="包含全部用户"
              inactive-text="不包含全部用户"
              @change="changSwitch"
            >
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-upload
              accept=".xls,.xlsx"
              :show-file-list="false"
              :on-success="onSuccess"
              :on-error="onError"
              style="display: inline-flex; margin-left: 20px"
              :action="
                action +
                '/' +
                (controlInfo && controlInfo.id) +
                '/' +
                allSwitchValue
              "
              :headers="headers"
            >
              <el-button size="mini" type="primary" icon="el-icon-upload2">
                上传表
              </el-button>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="downloadExcel()"
              >导出<i class="el-icon-download el-icon--right"></i
            ></el-button>
          </el-form-item>
        </el-form>

        <el-table class="box-table" :data="userList" v-loading="loading">
          <el-table-column prop="id" label="用户ID" align="center">
          </el-table-column>
          <el-table-column prop="name" label="用户名称" align="center">
          </el-table-column>
          <el-table-column label="添加时间" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.user.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button type="danger" size="small" @click="deleteUser(row)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 底部分页条 -->
        <el-pagination
          background
          :page-size="dataMeta.per_page || 15"
          :total="dataMeta.total || 0"
          :current-page="dataMeta.current_page"
          @current-change="handlePageChange"
          v-if="dataMeta && dataMeta.total > dataMeta.per_page"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'

import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { getCookie } from '@/utils/cookie'

export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false, //弹窗加载动画
      buttonLoading: false, //按钮加载动画
      query: {
        page: 1
      },
      user_id: undefined, //用户id
      allSwitchValue: 1, //0是不包含 1是包含 默认是0
      userList: undefined, //用户列表
      dataMeta: undefined, //底部跳转页面
    }
  },
  computed: {
    showMark: { //显示标志
      get() {
        return this.visible
      },
      set() { }
    },
    controlInfo: { //传来的数据
      get() {
        return this.value
      },
      set() { }
    },
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}water_control_import`
    }
  },

  watch: {
    showMark(val) {
      if (val) {
        this.getData()//查询数据
        this.allSwitchValue = this.controlInfo.is_include
      }
    }
  },
  created() {

  },
  methods: {
    getData() {
      //查询用户列表
      this.loading = true
      let params = {
        is_include: this.allSwitchValue,
        page: this.query.page,
        user_id: this.user_id
      }
      getApiData(`water_control/${this.controlInfo.id}/users`, params).then(res => {
        if (res) {
          this.userList = res.data
          //设置底部导航条数据
          this.dataMeta = res.meta
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      // 添加用户
      if (!this.user_id) {
        this.$message.warning('请先输入用户id')
        return
      }
      this.buttonLoading = true
      let params = {
        user_id: this.user_id,
        is_include: this.allSwitchValue
      }
      postApiData(`water_control/${this.controlInfo.id}/users`, params).then(res => {
        this.$message.success('添加成功！')
        this.getData()//刷新数据
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    changSwitch(val) {
      //全部用户是否包含
      this.allSwitchValue = val
      let params = {
        is_include: val
      }
      patchApiData(`water_control/${this.controlInfo.id}/users`, params)
        .then(res => {
          this.$message.success("保存成功！")
          this.getData()//刷新列表
          this.$emit('refresh')
        })
        .catch((err) => {
          this.allSwitchValue = this.allSwitchValue === 1 ? 0 : 1
        })

    },
    deleteUser(rowInfo) {
      //移除用户
      this.$confirm('确定要移除吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          id: rowInfo.user.id
        }
        delApiData(`water_control/${this.controlInfo.id}/users`, params).then(res => {
          this.$message.success('移除成功！')
          this.getData()
        })
      }).catch(() => { })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    closeDialog() {
      //关闭弹窗
      this.$emit('close')
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    downloadExcel() {
      //下载excel模版
      http
        .get(
          api + 'water_control_export/' + this.controlInfo.id,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '流水控制表.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  }
}

</script>
<style lang="less" scoped>
.set-user {
  .box-table {
    max-height: 400px;
    overflow-y: auto;
  }
}
</style>
